import { ILocationDecoded } from '@mopla/data-models';
import { getLocationCategory } from '@mopla/utils';

import { type H } from '../../services/hereapi/getH';
import { getHereSearch } from '../../services/hereapi/herePlatformAsync';

interface IResult {
	items: any[];
}

export const reverseGeocode = async (
	query: string,
	limit?: number
): Promise<ILocationDecoded[]> => {
	const hereSearch = await getHereSearch();

	return new Promise<ILocationDecoded[]>((resolve, reject) => {
		const parameters: H.service.ServiceParameters = {
			at: query,
			types: ['address'],
		};

		if (limit) {
			parameters['limit'] = limit;
		}

		hereSearch.reverseGeocode(
			parameters,
			(result: any) => {
				resolve(
					(result as IResult).items.map((suggestion) => {
						const {
							houseNumber = '',
							street,
							city,
							postalCode,
							stateCode,
							countryName,
						} = suggestion.address;

						const mappedItem: ILocationDecoded = {
							id: suggestion.id,
							position: suggestion.position,
							title: suggestion.address.label,
							address: {
								postalCode,
								stateCode,
								street,
								houseNumber,
								city,
								countryName,
							},
							type: getLocationCategory(suggestion, 'address'),
						};

						return mappedItem;
					})
				);
			},
			(err) => {
				reject(err);
			}
		);
	});
};
